export const SIZE_LIMIT = 1100;
